import { ChangeDetectorRef, Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  tap,
  mergeMap,
  withLatestFrom,
  exhaustMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromAuthActions from '../actions/auth.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { NavigationExtras, Router } from '@angular/router';
import { setLoadingSpinner } from '../actions/shared.action';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { getUserProfile } from '../actions/account.action';

@Injectable()
export class AuthEffects {

  login$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAuthActions.login),
      exhaustMap((action) => 
        this.authService.login(action?.data).pipe(
          map((response)=>{
            console.log(response);
            return fromAuthActions.loginSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAuthActions.loginFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  loginSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.loginSuccess),
        tap(async (action) =>{
          console.log("loginSuccess$",action.data);
          this.store.dispatch(getUserProfile());
        })
      ),
    { dispatch: false }
  );

  loginFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.loginFailed),
        tap(async (action) =>{
          console.log("loginFailed$",action.data);
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
          this.store.dispatch(setLoadingSpinner({status: false}));
        })
      ),
    { dispatch: false }
  );

  register$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAuthActions.register),
      exhaustMap((action) => 
        this.authService.register(action?.data).pipe(
          map((response)=>{
            console.log(response);
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAuthActions.registerSuccess({data: response?.message})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAuthActions.registerFailed({data : response?.error?.message}))
          })
        )
      )
    )
  )

  registerSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.registerSuccess),
        tap(async (action) =>{
          console.log("registerSuccess$",action.data);
          const message = {
            message: `You are now registered! We've sent verification to your registered email.`
          }
          this.modalService.successModal(message);
          this.router.navigateByUrl('/auth');
        })
      ),
    { dispatch: false }
  )

  registerFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.registerFailed),
        tap(async (action) =>{
          console.log("registerFailed$",action.data);
          if(action.data){
            this.modalService.errorModal(action?.data)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  )

  forgotPassword$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAuthActions.forgotPassword),
      exhaustMap((action) => 
        this.authService.forgotPassword(action?.data).pipe(
          map((response)=>{
            console.log(response);
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAuthActions.forgotPasswordSuccess({data: response?.message})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAuthActions.forgotPasswordFailed({data : response?.error?.message}))
          })
        )
      )
    )
  )

  forgotPasswordSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.forgotPasswordSuccess),
        tap(async (action) =>{
          console.log("forgotPasswordSuccess$",action.data);
          this.modalService.successModal(action.data)
        })
      ),
    { dispatch: false }
  )

  forgotPasswordFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.forgotPasswordFailed),
        tap(async (action) =>{
          console.log("forgotPasswordFailed$",action.data);
          if(action.data){
            this.modalService.errorModal(action?.data)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  )

  resetPassword$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAuthActions.resetPassword),
      exhaustMap((action) => 
        this.authService.resetPassword(action?.data).pipe(
          map((response)=>{
            console.log(response);
            this.store.dispatch(setLoadingSpinner({status : false}));
            return fromAuthActions.resetPasswordSuccess({data: response?.message})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAuthActions.resetPasswordFailed({data : response?.error?.message}))
          })
        )
      )
    )
  )

  resetPasswordSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.resetPasswordSuccess),
        tap(async (action) =>{
          console.log("resetPasswordSuccess$", action.data);
          this.modalService.successModal(action.data)
          this.router.navigateByUrl('/auth/login');
        })
      ),
    { dispatch: false }
  )

  resetPasswordFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAuthActions.resetPasswordFailed),
        tap(async (action) =>{
          console.log("resetPasswordFailed$",action.data);
          if(action.data){
            this.modalService.errorModal(action?.data)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  )

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private authService: AuthService,
    private router: Router,
    private modalService: ModalService
  ) {}
}
